<template>
  <span class="inline-block my-1 px-4 py-2 rounded-full text-[var(--base-secondary-text-color)] text-caption-medium ">
    <slot />
  </span>
</template>
